module.exports = "/images/pa.svg?b258f2e1c68d054ce9ad20640cddf912";